/**
 * Created by zhaojing on 2017/1/20.
 */


import Vue from 'vue';
import VueRouter from 'vue-router';

import './base/init';

// import MyAssets from '../component/MyAssets.vue';
import Loading from '../component/Loading.vue';
import Index from '../module/index/main';
import BlockInfo from '../module/index/blockInfo/main'
import TradeInfo from '../module/index/tradeInfo/main'
import SearchResult from '../module/index/searchResult/main'
import BlockAgent from '../module/index/blockAgent/main'

const router = new VueRouter({
    'routes': [
        {
            path: '/',
            name: 'index',
            component: Index
        },
        {
            path: '/blockInfo',
            name: 'blockInfo',
            component: BlockInfo
        },
        {
            path: '/tradeInfo',
            name: 'tradeInfo',
            component: TradeInfo
        },
        {
            path: '/searchResult',
            name: 'searchResult',
            component: SearchResult
        },
        {
            path: '/blockAgent',
            name: 'BlockAgent',
            component: BlockAgent
        }
    ]
});

const app = new Vue({
    router,
    components: {
        Loading,
        // MyAssets
    }
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/js/index.js